import { cn } from "@/lib/utils";

const CodeBlock = ({
  code,
  label,
  className,
}: {
  code: string;
  label?: string;
  className?: string;
}) => (
  <div
    className={cn(
      "flex w-full min-w-0 flex-col overflow-hidden rounded-xl border border-[#EFF2FF] bg-[#F9FBFF]",
      className,
    )}
  >
    {label && (
      <div className="border-b border-[#EFF2FF] px-4 py-2 text-[10.5px] font-semibold uppercase tracking-[0.14em] text-[#8B93A7]">
        {label}
      </div>
    )}
    <pre className="overflow-x-auto px-4 py-3.5 font-mono text-[12.5px] leading-[1.65] text-[#101828]">
      <code>{code}</code>
    </pre>
  </div>
);

export default CodeBlock;
